import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function IPBlockGuard({ children }) {
  const [isBlocked, setIsBlocked] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [blockedIP, setBlockedIP] = useState('');

  useEffect(() => {
    const checkIPStatus = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/my-ip`);
        if (response.data.is_blocked) {
          setIsBlocked(true);
          setBlockedIP(response.data.ip_address);
        }
      } catch (error) {
        // If we get a 403, we're blocked
        if (error.response?.status === 403) {
          setIsBlocked(true);
          setBlockedIP(error.response.data?.ip || 'Unknown');
        }
        // Otherwise, allow access (fail open for better UX)
      } finally {
        setIsChecking(false);
      }
    };

    checkIPStatus();
  }, []);

  // Show loading while checking
  if (isChecking) {
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center" data-testid="ip-check-loading">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-[#E85D75] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        </div>
      </div>
    );
  }

  // Show blocked message
  if (isBlocked) {
    return (
      <div className="min-h-screen bg-stone-900 flex items-center justify-center p-4" data-testid="ip-blocked-screen">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg 
              className="w-8 h-8 text-red-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" 
              />
            </svg>
          </div>
          <h1 className="text-2xl font-serif font-bold text-stone-800 mb-3">
            Access Denied
          </h1>
          <p className="text-stone-600 mb-6">
            Your IP address has been blocked from accessing this website.
          </p>
          <div className="bg-stone-100 rounded-lg p-4 mb-6">
            <p className="text-sm text-stone-500">Your IP Address</p>
            <p className="font-mono text-stone-800" data-testid="blocked-ip-value">{blockedIP}</p>
          </div>
          <p className="text-sm text-stone-500">
            If you believe this is an error, please contact the site administrator.
          </p>
        </div>
      </div>
    );
  }

  // Allow access
  return children;
}
